import Notification from "@/components/Notification";
import Vue from "vue"

const Notif = Vue.extend(Notification)

export default (text, type, position) => {
    const notification = new Notif({
        propsData: {
            text,
            type,
            position: position ? position : null
        }
    })
    notification.$mount()
    document.getElementById("app").appendChild(notification.$el)
}